import React from 'react';
import TdbIndividuelPage from './TdbIndividuelPage';

export default function TdbEmployePage() {
  return <TdbIndividuelPage />;
}
